import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { Profile } from '../models/profile';

export const GetProfileById = createAsyncThunk(
    'profilesData/getProfileById',
    async (id: string, { getState }: any) => {
        const axios = getState().core.axios;
        try {
            const response = await axios.get(`api/Profiles/${id}`);
            return response.data as Profile;
        } catch (error) {
            createNotification(
                'Something went wrong, could not load profile data. Please try again.',
                'error'
            );
            throw error;
        }
    }
);
